import { render, staticRenderFns } from "./editSucursal.vue?vue&type=template&id=4b0f25e4&scoped=true"
import script from "./editSucursal.vue?vue&type=script&lang=js"
export * from "./editSucursal.vue?vue&type=script&lang=js"
import style0 from "./editSucursal.vue?vue&type=style&index=0&id=4b0f25e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f25e4",
  null
  
)

export default component.exports